exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".whatido li[data-v-0e44d287]{margin-bottom:21px}.whatido li .card[data-v-0e44d287]{padding:21px 15px;border:1px solid #e7e7e7;border-radius:5px;cursor:pointer;-webkit-transition:all .6s ease;-moz-transition:all ease .6s;-o-transition:all ease .6s;transition:all .6s ease}.whatido li .card i[data-v-0e44d287]{font-size:4.5rem;color:#53bb34;margin-bottom:30px}.whatido li .card h3[data-v-0e44d287]{margin:0 0 21px;font:600 1.8rem Roboto,sans-serif;color:#707070}.whatido li .card p[data-v-0e44d287]{font-size:1.6rem}.whatido li .card[data-v-0e44d287]:hover{-webkit-transform:scale(1.03);-moz-transform:scale(1.03);-o-transform:scale(1.03);transform:scale(1.03)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0e44d287","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Whatido.vue
// module id = 61
// module chunks = 0